exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pointer[data-v-d3433c52] {\r\n  cursor: pointer;\n}\r\n", ""]);

// exports
